export default __webpack_public_path__ + "static/media/latestActive.415ccc1c.svg";